import {
  ApolloClient,
  from,
} from '@apollo/client';
import {
  cache,
} from './cache';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from "@apollo/client/link/retry";

const config = process.env
export const USER_KEY = "access_token";

const retryLink = new RetryLink();
const uri = config.REACT_APP_API_URL
const gqlURI = uri + 'graphql/';

// https://www.apollographql.com/blog/apollo-client/next-js/building-a-next-js-app-with-slash-graphql/

const authLink = setContext(async (_, { headers }) => {
  const token = localStorage.getItem(USER_KEY);
  // return the headers to the context so httpLink can read them
  const returnHeaders = {
    headers: {
      ...headers,
      Authorization: token ? `Token ${token}` : "",
    }
  }
  return returnHeaders
});

function createIsomorphLink() {
  const { HttpLink } = require('@apollo/client/link/http')
  return new HttpLink({
    uri: gqlURI,
  })
}

function createApolloClient() {
  return new ApolloClient({
    ssrMode: false,
    link: from([retryLink, authLink, createIsomorphLink()]),
    cache
  })
}

export const client = createApolloClient();
